import { onMounted, onUnmounted, ref, watch } from 'vue'
import { asyncTrack } from '@/track'

export function useTechAppHide() {
  const isHide = ref(false)
  const start = ref(0)
  const end = ref(0)

  function report(duration: number) {
    asyncTrack('tech_app_hide', {
      duration,
    })
  }

  function handleVisibilityChange() {
    isHide.value = document.hidden
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  watch(
    () => isHide.value,
    (val) => {
      if (!val) {
        start.value = performance.now()
      }
      else {
        end.value = performance.now()
        report(end.value - start.value)
      }
    },
    {
      immediate: true,
    },
  )

  return {
    handleVisibilityChange,
  }
}
